module.exports = __webpack_public_path__ + "img/fm.64202a50.svg";